__turbopack_context__.v({
  "dot": "nFRSeW_dot",
  "drawArea": "nFRSeW_drawArea",
  "drawWrapper": "nFRSeW_drawWrapper",
  "fadeIn": "nFRSeW_fadeIn",
  "globalStyle": "nFRSeW_globalStyle",
  "line": "nFRSeW_line",
});
